export default "assets/images/f7acb820d978ab2dd69e8bf695c574d1.png";